import React, { useLayoutEffect, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { Panel } from "../../components/Panel/Panel";
import { setSharedInfo } from "../../redux/actions/Settings";
import { getSavedConfiguration } from "../../api";
import { recalculateVh } from "../../utils/fix100vh";
import { WrapModals } from "../../components//Modals/Wrap/Wrap";

export const Main = () => {
  recalculateVh()
  const [mobileView, setMobileView] = useState(false);
  const [stepPanel, setStepPanel] = useState(1);
  const dispatch = useDispatch();
  
  useLayoutEffect(() => {
    function updateSize() {
        setMobileView(window.innerWidth < 993);
    }
    window.addEventListener("resize", updateSize);
  }, []);

  const search = useLocation().search;
  let idConfig = new URLSearchParams(search).get('sku');

  useEffect(() => {
    async function fetchConfig() {
      let result = await getSavedConfiguration({ configurationId: idConfig });
      await dispatch(setSharedInfo(result));
      
    }
    if (!!idConfig) {
      fetchConfig();
    }
  }, [])

  return (
      <>
        <Panel
            mobileView={mobileView}
            stepPanel={stepPanel}
            setStepPanel={setStepPanel}
        />
        <WrapModals />
      </>
  );
};
